import { fetchDeveloperApps } from "@/api/index";
import i18n from "@/i18n";

export const state = {
    apps: [],
    loadingApps: false
};
export const getters = {
    apps: ({ apps }) => apps,
    appsTableRow: ({ apps }) =>
        apps.map(item => {
            const row = ["clientName", "clientId", "status", "type"].map(
                key => {
                    const value = item[key];
                    const cell = { text: value || "-" };
                    switch (key) {
                    case "status":
                        cell.text = i18n.t("apps.status")[value];
                        break;
                    case "type":
                        cell.text = i18n.t("apps.type")[value];
                        break;
                    }
                    return cell;
                }
            );
            row.id = item.id;
            return row;
        }),
    appsByProjectId:
        ({ apps }) =>
            projectId =>
                apps.filter(({ project }) => project.id === projectId)
};
export const actions = {
    async FETCH_APPS({ commit, getters: { userId, projectId } }) {
        try {
            commit("SET_LOADING_APPS", true);
            const { data: apps } = await fetchDeveloperApps(userId);
            const appsByProjectId = apps.filter(
                app => projectId && app.project?.id === projectId
            );
            commit("SET_APPS", appsByProjectId);
        } catch (e) {
            //
        } finally {
            commit("SET_LOADING_APPS", false);
        }
    }
};
export const mutations = {
    SET_APPS(state, value) {
        state.apps = value;
    },
    SET_LOADING_APPS(state, value) {
        state.loadingApps = value;
    }
};
